export { ProcessWidget } from "./process_widget_container";
export { default as ProcessWidgetComponent } from "./process_widget";
export { default as ProcessWidgetEditor } from "./process_widget_editor";
import getResourceValue from "./get_resource_value";
import * as ProcessWidgetFactory from "./process_widget_factory";
export { default as WidgetEditProcess } from "./process_widget_form";

export { ProcessWidgetFactory, getResourceValue };
